<template>
  <CollapsibleSection
    v-if="getValue('client_type') === 'particulier'"
    title="Informations Particulier"
    icon="fas fa-home"
    context="quote"
    storage-key="particulier-info"
    :bare="bare"
  >
    <DetailItem label="Adresse" sensible>
      <input
        v-if="isEditing"
        type="text"
        v-model="editedQuote.particulier_adresse"
        class="form-control"
      />
      <template v-else>
        <span v-if="!isMissing(quote.particulier_adresse)">{{ quote.particulier_adresse }}</span>
        <DetailEmpty v-else />
      </template>
    </DetailItem>
    <DetailItem label="Code postal">
      <input
        v-if="isEditing"
        type="text"
        v-model="editedQuote.particulier_code_postal"
        pattern="[0-9]{5}"
        minlength="5"
        maxlength="5"
        @input="handleCodePostalInput"
        class="form-control"
      />
      <template v-else>
        <span v-if="!isMissing(quote.particulier_code_postal)">{{ quote.particulier_code_postal }}</span>
        <DetailEmpty v-else />
      </template>
    </DetailItem>
    <DetailItem label="Ville">
      <input
        v-if="isEditing"
        type="text"
        v-model="editedQuote.particulier_ville"
        class="form-control"
      />
      <template v-else>
        <span v-if="!isMissing(quote.particulier_ville)">{{ quote.particulier_ville }}</span>
        <DetailEmpty v-else />
      </template>
    </DetailItem>
    <template #footer>
      <slot name="footer" />
    </template>
  </CollapsibleSection>
</template>

<script setup>
import { CollapsibleSection, DetailItem, DetailEmpty } from '../data'
import { useFormFormatting } from '../../composables/useFormFormatting.js'

const props = defineProps({
  /** Rend la section sans carte ni en-tête, pour l'imbriquer dans un bloc regroupé. */
  bare: {
    type: Boolean,
    default: false
  },
  quote: {
    type: Object,
    required: true
  },
  isEditing: {
    type: Boolean,
    default: false
  },
  editedQuote: {
    type: Object,
    default: () => ({})
  },
  getValue: {
    type: Function,
    required: true
  }
})

const { formatCodePostal } = useFormFormatting()

const isMissing = (value) => {
  return !value || value === '' || value === null || value === undefined
}

const handleCodePostalInput = (event) => {
  const formatted = formatCodePostal(event.target.value)
  props.editedQuote.particulier_code_postal = formatted
}
</script>

<style scoped>
.form-control {
  width: 100%;
  padding: var(--spacing-sm) var(--spacing-md);
  border: 1px solid var(--color-border-dark);
  border-radius: var(--radius-sm);
  font-size: 1rem;
  font-family: inherit;
}

.form-control:focus {
  outline: 2px solid var(--color-info);
  outline-offset: 2px;
  border-color: var(--color-info);
  box-shadow: 0 0 0 3px var(--color-info-lighter);
}
</style>
